import React, { memo, useEffect } from 'react'
import { useDisconnect } from 'wagmi'

import { SplashScreen } from '../loading-screen'
import { DashboardLayout } from '../../layouts/dashboard'
import { disconnectMetamaskWallet } from '../../util/wallet/staking.helpers'

const AuthorizedLayout = ({ children, loading, initSignOut, ...restProps }) => {
  const { disconnect } = useDisconnect()
  useEffect(() => {
    if (initSignOut) {
      disconnect()
      disconnectMetamaskWallet()
    }
  }, [initSignOut])

  return loading ? (
    <SplashScreen />
  ) : (
    <DashboardLayout {...restProps}>{children}</DashboardLayout>
  )
}

export default memo(AuthorizedLayout)
